"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["item"],

  data: function data() {
    return {
      tableHeader: ["Anställda", "Testomgångar", "Testtillfället", "Testa", "Genomförd", "Genomfördes"]
    };
  },


  methods: {
    getDataForTable: function getDataForTable(data) {
      var arrayOfData = [];
      for (var occasion in data) {
        if (data.hasOwnProperty(occasion)) {
          var currentOccasion = data[occasion];
          for (var user in currentOccasion) {
            if (currentOccasion.hasOwnProperty(user)) {
              var currentUser = currentOccasion[user];
              for (var i = 0; i < currentUser.length - 1; i++) {
                if (i === 0) {
                  arrayOfData.push([this.getPersonalData(currentUser[i]), currentUser[i].roundName, currentUser[i].occasionName, currentUser[i].testName, currentUser[i].created_at ? "Ja" : "Nej", currentUser[i].created_at ? Fn.getFormattedDate(currentUser[i].created_at, "Y-MM-DD") : ""]);
                } else {
                  arrayOfData.push(["", "", "", currentUser[i].testName, currentUser[i].created_at ? "Ja" : "Nej", currentUser[i].created_at ? Fn.getFormattedDate(currentUser[i].created_at, "Y-MM-DD") : ""]);
                }
              }
            }
          }
        }
      }

      return arrayOfData;
    },
    getPersonalData: function getPersonalData(emploee) {
      var data = "Namn: " + emploee.firstname + " " + emploee.lastname + "<br>" + "E-post: " + emploee.email + "<br>" + "Företag: " + emploee.companyName + "<br>";

      if (emploee.officeName) {
        data = data + "Kontor: " + emploee.officeName + "<br>";
      }

      if (emploee.departmentName) {
        data = data + "Avdelningar: " + emploee.departmentName;
      }

      return data;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/tables/StatisticsTable.vue
// module id = sAVa
// module chunks = 0 1